"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const icons_1 = require("../../../../assets/icons");
const User_1 = __importDefault(require("../../../../networking/apis/User"));
const scale_1 = require("../../../../utils/scale");
const components_1 = require("../../components");
const NotifySettings = (props) => {
    const { user } = props;
    const [modalVisible, setModalVisible] = (0, react_1.useState)(false);
    const refTimeout = (0, react_1.useRef)();
    (0, react_1.useEffect)(() => {
        return () => {
            clearTimeout(refTimeout.current);
        };
    }, []);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_native_1.TouchableOpacity, { style: styles.settingButton, onPress: () => setModalVisible(true) },
            react_1.default.createElement(icons_1.IC_SETTING, { width: (0, scale_1.scale)(20), height: (0, scale_1.scale)(20) })),
        react_1.default.createElement(components_1.ModalNotifySetting, { visible: modalVisible, disabled: !user.individual_notification_settings, tagName: `@${user?.user_handle}`, defaultValue: [
                !!user?.individual_notification_settings?.timeline_posted_notification,
                !!user?.individual_notification_settings?.article_posted_notification,
                !!user?.individual_notification_settings?.personal_history_posted_notification
            ], onToggle: (array) => {
                clearTimeout(refTimeout.current);
                refTimeout.current = setTimeout(() => {
                    User_1.default.updateUserIndividualNotificationSetting(user.user_id, {
                        timeline_posted_notification: array[0] ? 1 : 0,
                        article_posted_notification: array[1] ? 1 : 0,
                        personal_history_posted_notification: array[2] ? 1 : 0
                    })
                        .catch(err => {
                        console.log(err);
                    });
                }, 1000);
            }, onClose: () => {
                setModalVisible(false);
            } })));
};
exports.default = NotifySettings;
const styles = react_native_1.StyleSheet.create({
    settingButton: {
        width: (0, scale_1.scale)(32),
        height: (0, scale_1.scale)(32),
        borderWidth: (0, scale_1.scale)(1),
        borderRadius: (0, scale_1.scale)(3),
        borderColor: "#AAAAAA",
        justifyContent: "center",
        alignItems: "center",
    },
});
